import angular from 'angular'
import component from './social-media-approver.component'
import curatorSyncStatus from 'components/curator-sync-status'

export default angular.module('socialmediaapprover', [
  curatorSyncStatus
])
  .component('socialmediaapprover', component)
  .directive('videoDurationCheck', function () {
    return {
      restrict: 'A',
      scope: {
        post: '=videoDurationCheck',
        maxLength: '=videoMaxLength'
      },
      link: function (scope, element) {
        element.on('loadedmetadata', function () {
          scope.$apply(function () {
            scope.post.duration = Math.round(element[0].duration)
            scope.post.videoTooLong = element[0].duration > scope.maxLength
          })
        })
      }
    }
  })
